module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_duo_cp_gaseosas_pet_500_sp.2b5f5409.png";